import React, { useState, useEffect } from 'react'
import { Typography } from 'antd'

const { Title } = Typography

const Home = () => {

  const words = [
    { text: "BTM", color: "#ff6b6b" },    // Red
    { text: "ROI", color: "#4ecdc4" },    // Turquoise
    { text: "FAFO", color: "#5bc0de" },   // Light Cyan (was #45b7d1)
    { text: "CTO", color: "#96c93d" },    // Lime Green
    { text: "COREG", color: "#e0a824" },  // Deeper Gold (was #f7b731)
    { text: "DIT", color: "#e65c00" },    // Orange-Red (was #e74c3c)
    { text: "MMT", color: "#3498db" },    // Bright Blue
    { text: "CJ", color: "#2ecc71" },     // Emerald Green
    { text: "DMA", color: "#e67e22" },    // Orange
    { text: "FUNNELS", color: "#8e44ad" },    // Deep Purple
    { text: "IP REP", color: "#1abc9c" },   // Teal
    { text: "ROAS", color: "#d35400" },   // Pumpkin
    { text: "CTR", color: "#27ae60" },    // Forest Green
    { text: "CVR", color: "#c0392b" },    // Dark Red
    { text: "AOV", color: "#16a085" },    // Dark Teal
    { text: "CPL", color: "#e6b800" },    // Darker Yellow (was #f1c40f)
    { text: "DOMAIN REP", color: "#8c7ae6" },    // Soft Purple
    { text: "SPLIT TESTS", color: "#e84393" },     // Magenta
    { text: "SPEED", color: "#9b59b6" }     // Muted Purple
  ]

  const [currentIndex, setCurrentIndex] = useState(-1)
  const [isCycling, setIsCycling] = useState(true)

  useEffect(() => {

    let intervalId
    
    if (isCycling) {

      intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => {

          const nextIndex = prevIndex + 1

          if (nextIndex >= words.length) {

            setIsCycling(false)
            return Math.floor(Math.random() * words.length)
          }

          return nextIndex
        })
      }, 100)

    } else {

      intervalId = setTimeout(() => {
        setIsCycling(true)
        setCurrentIndex(-1)
      }, 5000)
    }

    return () => {
      
      if (intervalId) isCycling ? clearInterval(intervalId) : clearTimeout(intervalId)
    }
  }, [isCycling])

  return (
    <Title style={{ 
      alignItems: 'center',
      display: 'flex',
      fontSize: '6rem',
      fontWeight: 'bold',
      fontFamily: 'Arial, sans-serif',
      height: '250px'
    }}>
      <span style={{marginRight: '25px'}}>Focus on</span> 
      {currentIndex >= 0 && (
        <span style={{ 
          color: words[currentIndex].color,
          transition: 'color 0.1s ease, text-shadow 0.3s ease'
        }}>
          {words[currentIndex].text}
        </span>
      )}
    </Title>
  )
}

export default Home